import { fetchJSON } from "../util/fetch-utils";
export default class VelavuAPIInvoices {
    //This method returns all invoices associated with a customer
    getAllInvoices() {
        return fetchJSON("/invoices");
    }
    //This method returns a draft of the upcoming invoice for this billing cycle
    getUpcomingInvoice() {
        return fetchJSON("/invoices/upcoming");
    }
}
//# sourceMappingURL=velavu-api-invoices.js.map